import {
  ChangeDetectionStrategy,
  Component,
  HostBinding,
  Input,
  OnInit,
} from '@angular/core';
import { isDefined } from '@sama/js-core';
import { last, uniqueId } from '@sama/micro-dash';
import { DirectiveSuperclass } from '@sama/ng-core';
import { combineLatest, Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import {
  Point2D,
  VisibilityState,
} from '../../../../team-apis/otterdam/answers/shape-typings';
import { getPointString } from '../../shapes/abstract-shape-helpers';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector -- svg needs attribute selectors
  selector: '[h3ShapeFill]',
  templateUrl: './shape-fill.component.html',
  styleUrls: ['./shape-fill.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class ShapeFillComponent extends DirectiveSuperclass implements OnInit {
  @Input({ required: true }) points!: Point2D[];
  @Input({ required: true }) visibility!: VisibilityState;
  @Input() outline = true;
  @Input() @HostBinding('class.selected') selected = false;
  @Input() mlIsLoading = false;
  @Input({ required: true }) scale$!: Observable<number>;

  patternTransform$!: Observable<string>;
  patternId = uniqueId('fill-pattern-');
  getPointString = getPointString;

  trackByIndex = (index: number) => index;

  ngOnInit() {
    this.patternTransform$ = this.buildPatternTransform$();
  }

  getFill() {
    return this.visibility === 0.5 ? `url(#${this.patternId})` : undefined;
  }

  private buildPatternTransform$(): Observable<string> {
    return combineLatest([
      this.getInput$('points').pipe(map(last), filter(isDefined)),
      this.scale$,
    ]).pipe(
      map(
        ([offset, scale]) =>
          `
            translate(${offset.join()})
            rotate(45)
            scale(${1 / scale})
          `,
      ),
    );
  }
}
